export const idx_data_weight_hole_position = [];

idx_data_weight_hole_position.push({
  position: '',
});

idx_data_weight_hole_position.push({
  position: 'NONE',
});

idx_data_weight_hole_position.push({
  position: 'P0.5',
});

idx_data_weight_hole_position.push({
  position: 'P1',
});

idx_data_weight_hole_position.push({
  position: 'P1.5',
});

idx_data_weight_hole_position.push({
  position: 'P2',
});

idx_data_weight_hole_position.push({
  position: 'P2.5',
});

idx_data_weight_hole_position.push({
  position: 'P3',
});

idx_data_weight_hole_position.push({
  position: 'P3.5',
});

idx_data_weight_hole_position.push({
  position: 'P4',
});

idx_data_weight_hole_position.push({
  position: 'Motion Hole',
});

idx_data_weight_hole_position.push({
  position: 'PAP',
});
